/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  MailTemplateVariableObject,
  MailTemplateVariableObjectFromJSON,
  MailTemplateVariableObjectFromJSONTyped,
  MailTemplateVariableObjectToJSON
} from './MailTemplateVariableObject'

/**
 *
 * @export
 * @interface VariablesMailTemplateResponseData
 */
export interface VariablesMailTemplateResponseData {
  /**
   *
   * @type {Array<MailTemplateVariableObject>}
   * @memberof VariablesMailTemplateResponseData
   */
  mailTemplateVariableObjects?: Array<MailTemplateVariableObject>
}

export function VariablesMailTemplateResponseDataFromJSON(json: any): VariablesMailTemplateResponseData {
  return VariablesMailTemplateResponseDataFromJSONTyped(json, false)
}

export function VariablesMailTemplateResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VariablesMailTemplateResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    mailTemplateVariableObjects: !exists(json, 'mail_template_variable_objects')
      ? undefined
      : (json['mail_template_variable_objects'] as Array<any>).map(MailTemplateVariableObjectFromJSON)
  }
}

export function VariablesMailTemplateResponseDataToJSON(value?: VariablesMailTemplateResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    mail_template_variable_objects:
      value.mailTemplateVariableObjects === undefined
        ? undefined
        : (value.mailTemplateVariableObjects as Array<any>).map(MailTemplateVariableObjectToJSON)
  }
}
